export enum UnaddressedEmissionsDisplay {
  None = 'None',
  TotalBarOnly = 'TotalBarOnly',
  TotalBarAndDiagrams = 'TotalBarAndDiagrams',
}
